import {v4 as uuidv4} from "uuid";
import {useContext, useEffect, useRef} from "react";
import {IonItem, IonLabel, IonList} from "@ionic/react";

import {AuthContext} from "../../context/AuthContext";
import "./search.styles.css";
import {useHistory} from "react-router";

//
interface ISearchProps {
  searchText: string;
  onInputChange: (e: any) => void;
  searchResult: any[];
  hideSearch: () => void;
}

/**
 *
 */
const Search = (props: ISearchProps) => {
  const history = useHistory();

  const {addToCart} = useContext(AuthContext);

  const inputRef = useRef<HTMLInputElement | null>(null);

  const addItemToCart = (item: any) => {
    props.hideSearch();
    addToCart(item.id, item.name, uuidv4());

    //
    history.push("/personale/add-to-cart");
  };

  useEffect(() => {
    inputRef?.current?.focus?.();
  }, []);

  //
  return (
    <div className="search-container">
      <input
        type="text"
        id="search-text"
        className="navbar-search navbar-search-mobile"
        placeholder="Cerca un servizio"
        defaultValue={props.searchText}
        onChange={props.onInputChange}
        ref={inputRef}
      />

      <IonList className="search-ionlist">
        {props.searchResult?.length > 0 ? (
          props.searchResult.map((item: any, index: number) => (
            <IonItem button key={index} onClick={() => addItemToCart(item)}>
              <IonLabel>{item.name}</IonLabel>
            </IonItem>
          ))
        ) : (
          <div className="flex-justify-center cart-container text-center">
            Nessun risultato
          </div>
        )}
      </IonList>
    </div>
  );
};
export default Search;
